import { Card, CardActionArea, CardContent, SxProps, Theme } from "@mui/material";
import * as React from "react";

interface ClickableCardProps {
  children: React.ReactNode;
  elevation?: number;
  onClick?: () => void;
  cardSxProps?: SxProps<Theme>;
  cardActionAreaSxProps?: SxProps<Theme>;
  cardContentSxProps?: SxProps<Theme>;
}

export const ClickableCard = ({
  children,
  elevation,
  onClick,
  cardSxProps = [],
  cardActionAreaSxProps = [],
  cardContentSxProps = [],
}: ClickableCardProps) => {
  return (
    <Card
      aria-label={"clickable-card-component"}
      elevation={elevation ? elevation : 0}
      onClick={onClick}
      sx={[...(Array.isArray(cardSxProps) ? cardSxProps : [cardSxProps])]}
    >
      {onClick ? (
        <CardActionArea
          sx={[
            ...(Array.isArray(cardActionAreaSxProps)
              ? cardActionAreaSxProps
              : [cardActionAreaSxProps]),
          ]}
        >
          <CardContent
            sx={[
              ...(Array.isArray(cardContentSxProps) ? cardContentSxProps : [cardContentSxProps]),
            ]}
          >
            {children}
          </CardContent>
        </CardActionArea>
      ) : (
        <CardContent
          sx={[...(Array.isArray(cardContentSxProps) ? cardContentSxProps : [cardContentSxProps])]}
        >
          {children}
        </CardContent>
      )}
    </Card>
  );
};
